import { render, staticRenderFns } from "./Jumbotron.vue?vue&type=template&id=56a16ab6&scoped=true&"
import script from "./Jumbotron.vue?vue&type=script&lang=js&"
export * from "./Jumbotron.vue?vue&type=script&lang=js&"
import style0 from "./Jumbotron.vue?vue&type=style&index=0&id=56a16ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a16ab6",
  null
  
)

export default component.exports